import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';

const DetailTable = ({ label, item }) => {

  const viewRow = (rowItem) => {
    if (item === 'OK') {
      return <div styleName="ok-item">{rowItem}</div>;
    } else if (item === 'Error') {
      return <div styleName="error-item">{rowItem}</div>;
    } else if (item === 'Warning') {
      return <div styleName="warning-item">{rowItem}</div>;
    }
    return <div styleName="item">{rowItem}</div>;
  };

  return (
    <row styleName="row">
      <div styleName="label">{label}</div>
      {viewRow(item)}
    </row>
  );
};

DetailTable.propTypes = {
  label: PropTypes.string,
  item: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

DetailTable.defaultProps = {
  label: '',
  item: '',
};

export default CSSModules(DetailTable, styles, { allowMultiple: true });
